import { RequestsWidget } from '@ankr.com/telemetry';

import { RequestsWidgetPlaceholder } from 'modules/stats/components/RequestsWidgetPlaceholder';
import { getRequestsChartTranslations } from 'modules/stats/utils/getRequestsChartTranslations';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTimeframe } from 'modules/chains/components/TimeframeProvider';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { WidgetSection } from '../WidgetSection';
import { requestsChartTranslation } from './translation';
import { useStats } from '../StatsProvider';
import { useRequestsChartStyles } from './useRequestsChartStyles';

export const RequestsChart = () => {
  const { isLoggingIn } = useAuth();
  const { loading, requestsChartData } = useStats();
  const { timeframe } = useTimeframe();

  const { keys, t } = useTranslation(requestsChartTranslation);
  const { classes } = useRequestsChartStyles();

  return (
    <WidgetSection title={t(keys.title)}>
      <RequestsWidget
        NoDataPlaceholder={RequestsWidgetPlaceholder}
        className={classes.root}
        data={requestsChartData}
        isLoading={loading || isLoggingIn}
        isTitleHidden
        timeframe={timeframe}
        translation={getRequestsChartTranslations()}
      />
    </WidgetSection>
  );
};
